import { FC } from 'react';
import { Icon } from 'common-components';
import { LeftMenuProps, MenuItems } from './leftMenuTypes';
import './leftMenu.scss';

const LeftMenu: FC<LeftMenuProps> = (props: LeftMenuProps) => {
    const { selectedItem, onClick } = props;
    const onItemClick = (item: keyof typeof MenuItems) => {
        const isNewItem = selectedItem !== item;
        if (isNewItem) {
            onClick(item);
        }
    };

    const isSelected = (item: keyof typeof MenuItems) => {
        const isCoursePage = item === 'learn' && selectedItem === 'course';
        return isCoursePage || item === selectedItem;
    };

    const getIconWrapperClassName = (item: keyof typeof MenuItems) => {
        return isSelected(item) ? 'selected-icon-wrapper' : 'icon-wrapper';
    };

    return (
        <div className="left-menu">
            <img src={`${process.env.PUBLIC_URL}/images/cxSmallLogo.svg`} className="cb-logo" alt="Codebashing Logo" />
            <div className="icons-wrapper">
                <div className={getIconWrapperClassName('home')} onClick={() => onItemClick('home')}>
                    <Icon name="homeIcon" className="icon"></Icon>
                </div>
                <div className={getIconWrapperClassName('learn')} onClick={() => onItemClick('learn')}>
                    <Icon name="learnIcon" className="icon"></Icon>
                </div>
                <div className={getIconWrapperClassName('play')} onClick={() => onItemClick('play')}>
                    <Icon name="playIcon" className="icon"></Icon>
                </div>
                <div className={getIconWrapperClassName('test')} onClick={() => onItemClick('test')}>
                    <Icon name="testIcon" className="icon"></Icon>
                </div>
            </div>
        </div>
    );
};

export default LeftMenu;
